import { createContext } from 'react';
import {
    QUERY_KEYS_ESUS,
    useChartsData
} from '../../../Common/Filters/useChartsData';
import { useFiltersContext } from '../../../../Common/Filters/hooks/useFiltersContext';

export const SchedulingChartsDataContext = createContext();

const SchedulingChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_ESUS.GENERAL_RESULTS_SCHEDULING,
            url: 'governanceroom/esus/generalresults/appointments'
        },
        {
            year: filters.ano.value,
            month: filters.competencia.map((competencia) => competencia.value),
            location: filters.unidade.value,
            city: filters.cidade?.governance_room_geo_city_id,
        }
    );

    const chartData = data
        ? {
              indicators: {
                  appointmentsMade: data?.indicators?.appointmentsMade ?? 0,
                  allAppointments: data?.indicators?.allAppointments ?? 0,
                  appointmentsBalance:
                      data?.indicators?.appointmentsBalance ?? 0,
                  balancePercentage: data?.indicators?.balancePercentage ?? 0
              },
              appointmentsBySituations: data.appointmentsBySituations ?? [],
              tableSceduling: data.tableSceduling ?? []
          }
        : {
              indicators: {
                  appointmentsMade: 0,
                  allAppointments: 0,
                  appointmentsBalance: 0,
                  balancePercentage: 0
              },
              appointmentsBySituations: [],
              tableSceduling: []
          };

    return (
        <SchedulingChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </SchedulingChartsDataContext.Provider>
    );
};

export default SchedulingChartsDataProvider;
